export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "faq-1",
    question: "caoliu 是什么？",
    answer: "caoliu 是一个综合性的中文在线社区平台，汇集了丰富多样的内容版块和交流功能。用户可以在 caoliu 上浏览和分享各类资源、参与话题讨论、结交志同道合的朋友。凭借多年的运营积累，caoliu 已成为中文互联网上最具影响力的社区之一。",
  },
  {
    id: "faq-2",
    question: "如何找到 caoliu 的最新官方入口？",
    answer: "您可以通过以下途径获取 caoliu 的最新官方入口：1）收藏本网站的官方入口页面，我们会实时更新最新地址；2）关注 caoliu 官方社交媒体账号；3）加入 caoliu 官方 Telegram 频道；4）通过搜索引擎搜索 'caoliu 最新地址' 找到我们。请务必通过官方渠道获取地址，避免访问钓鱼站点。",
  },
  {
    id: "faq-3",
    question: "caoliu 需要付费使用吗？",
    answer: "caoliu 的基础功能完全免费，所有用户都可以免费注册账号、浏览内容、参与讨论。caoliu 也提供可选的 VIP 会员服务，VIP 会员可以享受无广告浏览、高速下载、专属标识等额外权益。是否开通 VIP 完全由用户自行选择。",
  },
  {
    id: "faq-4",
    question: "访问 caoliu 需要特殊的网络工具吗？",
    answer: "由于网络环境的复杂性，部分地区的用户在直接访问 caoliu 时可能会遇到困难。我们建议用户使用 VPN 服务、配置代理服务器或修改 DNS 设置来获得更稳定的访问体验。具体方案请参考我们网站上的「安全访问」分类下的相关教程。",
  },
  {
    id: "faq-5",
    question: "caoliu 账号被盗了怎么办？",
    answer: "如果发现账号异常，请立即采取以下措施：1）使用'找回密码'功能尝试重置密码；2）检查绑定邮箱是否被篡改；3）立即联系 caoliu 官方客服进行账号冻结和申诉；4）恢复账号后第一时间开启两步验证（2FA），并更换高强度密码。",
  },
  {
    id: "faq-6",
    question: "caoliu 支持哪些设备和浏览器？",
    answer: "caoliu 已针对桌面端和移动端进行了全面的响应式适配。支持所有主流浏览器，包括 Chrome、Firefox、Safari、Edge 等。移动端用户可以直接使用手机浏览器访问，无需安装额外应用。推荐使用 Chrome 浏览器以获得最佳体验。",
  },
  {
    id: "faq-7",
    question: "如何在 caoliu 发布内容？",
    answer: "注册并登录 caoliu 账号后，进入您感兴趣的版块，点击'发布新帖'按钮即可开始创作。发布前请仔细阅读社区版规和发布规范，确保内容符合社区要求。高质量的原创内容更容易获得社区推荐和其他用户的认可。",
  },
  {
    id: "faq-8",
    question: "caoliu 的镜像站点和官方站点有什么区别？",
    answer: "镜像站点是官方站点的完整复制，内容与官方站点完全同步。镜像站点部署在全球不同地区的服务器上，主要目的是为不同地区的用户提供更快的访问速度。当某个节点不可用时，用户可以切换到其他镜像站点。所有镜像站点均通过官方认证，安全性有保障。",
  },
];